import AddIcon from '@mui/icons-material/Add'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import SubmitButton from '@/features/bidding/components/SubmitButton'
import { useIsFetchingAnyBid } from '@/features/bidding/hooks/useIsFetchingAnyBid'
import { useIsSavingBids } from '@/features/bidding/hooks/useSaveBidsMutation'

type Props = {
  disabled?: boolean
  isValidatingRegulationObject?: boolean
  shouldShowConfirmation?: boolean
  onSubmit: () => void | Promise<void>
  dialogProps: {
    title: string
    description: string
  }
}

const CreateBidButton: FC<Props> = ({
  disabled,
  isValidatingRegulationObject = false,
  shouldShowConfirmation,
  onSubmit,
  dialogProps,
}) => {
  const { t } = useTranslation()
  const isFetchingAnyBid = useIsFetchingAnyBid()
  const isSavingAnyBids = useIsSavingBids()

  const isLoading = isValidatingRegulationObject || isFetchingAnyBid || isSavingAnyBids

  return (
    <SubmitButton
      buttonProps={{
        disabled: disabled,
        startIcon: <AddIcon />,
        'data-testid': 'create-bid-button',
      }}
      dialogProps={dialogProps}
      isLoading={isLoading}
      shouldShowConfirmation={shouldShowConfirmation}
      onSubmit={onSubmit}
    >
      {t('bidding.create_bid.create')}
    </SubmitButton>
  )
}

export default CreateBidButton
